/* BLACK INDUSTRY — mobile homepage featured-products carousel */
(() => {
  const SwiperComponent = customElements.get('swiper-component');
  if (!SwiperComponent || SwiperComponent.prototype.__blackIndustryPatched) return;

  const originalInit = SwiperComponent.prototype.init;

  SwiperComponent.prototype.init = function () {
    const isHomepageFeaturedProducts =
      document.body.classList.contains('template--index') &&
      this.closest('.section--featured-products');

    if (isHomepageFeaturedProducts) {
      this.swiperOptions = {
        ...this.swiperOptions,
        slidesPerView: 2,
        allowTouchMove: true,
        followFinger: true,
        spaceBetweenMobile: 8
      };
    }

    return originalInit.call(this);
  };

  SwiperComponent.prototype.__blackIndustryPatched = true;
})();
